import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import DFNewsSider from './dfNewsSider';
import DFNews from './dfNews';

class DigitalAndFo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { dfNewsSiderData, dfNewsData },
        } = this.props;

        return (
            <div className={styles.box}>
                <NoSSR>
                    <DFNewsSider content={dfNewsSiderData} />
                </NoSSR>
                <DFNews content={dfNewsData} />
            </div>
        );
    }
}

export default errorBoundary(DigitalAndFo);
